import { render } from "./Popover.vue?vue&type=template&id=4f344738&ts=true"
import script from "./Popover.vue?vue&type=script&lang=ts"
export * from "./Popover.vue?vue&type=script&lang=ts"

import exportComponent from "/fides/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__